"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RollbarModule = void 0;
var core_1 = require("@angular/core");
var rollbar_service_1 = require("./rollbar.service");
var i0 = require("@angular/core");
var RollbarModule = /** @class */ (function () {
    function RollbarModule() {
    }
    /**
     *
     * Setup the module in your application's root bootstrap.
     *
     * @static
     * @param {RollbarConfig} config The configuration for Rollbar logging
     * @returns {ModuleWithProviders} The module ready for your bootstrap
     *
     * @memberOf RollbarModule
     */
    RollbarModule.forRoot = function (config) {
        return {
            ngModule: RollbarModule,
            providers: [{ provide: rollbar_service_1.ROLLBAR_CONFIGURATION, useValue: config }],
        };
    };
    RollbarModule.ɵmod = i0.ɵɵdefineNgModule({ type: RollbarModule });
    RollbarModule.ɵinj = i0.ɵɵdefineInjector({ factory: function RollbarModule_Factory(t) { return new (t || RollbarModule)(); }, providers: [rollbar_service_1.RollbarService] });
    return RollbarModule;
}());
exports.RollbarModule = RollbarModule;
/*@__PURE__*/ (function () { i0.ɵsetClassMetadata(RollbarModule, [{
        type: core_1.NgModule,
        args: [{
                providers: [rollbar_service_1.RollbarService],
            }]
    }], null, null); })();
